import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useOrganisation } from "../../contexts/OrganisationContext";
import { formatRoleName } from "../../utils/tokenUtils";

/**
 * Displays basic user information and permissions.
 */
function UserProfileCard() {
    const { user, roles, loading } = useAuth();
    const { activeRoleId, activeOrgId, organisations } = useOrganisation();
    
    const activeOrganisation = organisations.find(org => org.id === activeOrgId);

    if (loading) {
        return <div>Loading...</div>;
    }
    console.log("User:" + user);
    return (
    <div
      style={{
        backgroundColor: "white",
        padding: "2rem 3rem",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        textAlign: "center",
        maxWidth: "500px",
        width: "100%",
      }}
    >
      <h1
        className="ids-heading-l"
        style={{ color: "var(--ids-palette-primary-40)", fontFamily: '"Poppins"' }}
      >
        Profil
      </h1>

      {/* User information */}
      <p style={{ marginTop: "1.5rem", fontSize: "1rem" }}>
        <strong>Användarnamn:</strong> {user?.username || 'Unknown'}
      </p>
      <p style={{ fontSize: "1rem" }}>
          <strong>Organisation:</strong> {activeOrganisation?.displayName ?? activeOrganisation?.name ?? 'Unknown'}
      </p>
      <p style={{ fontSize: "1rem" }}>
          <strong>Roll:</strong> {formatRoleName(activeRoleId) || 'Unknown'}
      </p>
    </div>
  );
}

export default UserProfileCard;
